import { dateFilterTypes } from "../../utils";

export const filterInitialValues = {
    filter: [
        {
            number: '',
            a_filter_type: '',
            placeholder: 'Enter Number',
            type: 'number',
            shouldFilterOptionDisabled: false,
            label: 'Number',
        },
        {
            destination: '',
            a_filter_type: '',
            placeholder: 'Enter Destination',
            type: 'text',
            shouldFilterOptionDisabled: false,
            label: 'Destination',
        },
        {
            date: {
                from: '',
                to: '',
            },
            a_filter_type: '',
            placeholder: 'Custom Date Range...',
            type: 'date',
            shouldFilterOptionDisabled: false,
            filterOptions: dateFilterTypes,
            selectOptions: [],
            label: 'Date',
        },
    ],
};